import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ADMIN_EMAIL = 'admin@propert.com';
const ADMIN_PASS = "jPR'6Ma1Alu:8Ls>SE71";

export const useAdminAuth = () => {
     // Revisa si hay una sesión de admin activa en localStorage
     const [isAdmin, setIsAdmin] = useState(() => !!localStorage.getItem('isAdminAuthenticated'));
     const navigate = useNavigate();

     const loginAdmin = (email, password) => {
          if (email === ADMIN_EMAIL && password === ADMIN_PASS) {
               localStorage.setItem('isAdminAuthenticated', 'true');
               setIsAdmin(true);
               navigate('/admin/pending-kyc-users'); // Redirige al dashboard de admin
               return true;
          }
          alert('Credenciales de administrador incorrectas.');
          return false;
     };

     const logoutAdmin = () => {
          localStorage.removeItem('isAdminAuthenticated');
          setIsAdmin(false);
          navigate('/admin');
     };

     return { isAdmin, loginAdmin, logoutAdmin };
};

// Hook simple para verificar si está logueado, para usar en el guardián de rutas
export const isAdminLoggedIn = () => {
     return !!localStorage.getItem('isAdminAuthenticated');
};